let IssueStyle = {
   bottomMenuHeight: 40,
   issueIndexHeight: 140
}

export {IssueStyle}